import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../../context';
import { UserNotificationAchievementKind } from '../../../services';
import { PreferenceRow, PreferencesSection } from '../PreferencesSection';
import { SettingsSection } from '../SettingsSection';
import { useNotificationPreference } from '../useNotificationPreference';

interface AchievementsSectionProps {
  isPushLocked?: boolean;
}

export const AchievementsSection: FunctionComponent<AchievementsSectionProps> = ({
  isPushLocked,
}) => {
  const { t: ctxT } = useTranslation('', { keyPrefix: 'pushNotifications' });

  const { leaderBoardBadge } = useContext(UserContext).userProfile;

  const { preference, setPushEnabled, setEmailEnabled } = useNotificationPreference();

  if (!leaderBoardBadge || !preference) {
    return null;
  }

  return (
    <SettingsSection title={ctxT('achievements-title')} hint={ctxT('achievements-hint')}>
      <PreferencesSection>
        {Object.values(UserNotificationAchievementKind).map((kind) => {
          const { push, email } = preference[kind];

          return (
            <PreferenceRow
              key={kind}
              label={ctxT(`achievements-${kind}`)}
              isPushEnabled={push}
              onPushChange={(isEnabled) => setPushEnabled({ kind, isEnabled })}
              onEmailChange={(isEnabled) => setEmailEnabled({ kind, isEnabled })}
              isPushLocked={isPushLocked}
              isEmailEnabled={email}
            />
          );
        })}
      </PreferencesSection>
    </SettingsSection>
  );
};
